import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import App from './App';
import SiderBar from './components/SiderBar';
import Footer from './components/Footer';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import { UserProvider } from './context/User';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { StatusProvider } from './context/Status';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StatusProvider>
      <UserProvider>
        <BrowserRouter>
          <div className='app-shell'>
            <aside className='sidebar-wrapper'>
              <SiderBar />
            </aside>
            <div className='content-shell'>
              <main className='main-content'>
                <App />
              </main>
              <ToastContainer />
              <div className='content-footer'>
                <Footer />
              </div>
            </div>
          </div>
        </BrowserRouter>
      </UserProvider>
    </StatusProvider>
  </React.StrictMode>
);
